type DesktopMessageNotificationInput = {
  isDndQuiet: boolean;
  isMine: boolean;
  isMuted: boolean;
  messageType?: string | null;
  isActiveConversation: boolean;
  isWindowVisible: boolean;
};

// Chat currently keeps a durable socket for global alerts as well as a chat-page
// socket for the live timeline. Either can receive the same message first; keep
// the native alert exactly-once without depending on socket ordering.
const claimedMessageNotifications = new Map<string, number>();
const CLAIM_TTL_MS = 5 * 60_000;

export function claimDesktopMessageNotification(messageId: string, now = Date.now()): boolean {
  if (!messageId) return false;

  for (const [id, claimedAt] of claimedMessageNotifications) {
    if (now - claimedAt >= CLAIM_TTL_MS) claimedMessageNotifications.delete(id);
  }
  if (claimedMessageNotifications.has(messageId)) return false;
  claimedMessageNotifications.set(messageId, now);
  return true;
}

/**
 * A notification is useful when a message arrives outside the conversation
 * being read, or while its desktop window is hidden. Electron's authoritative
 * window visibility is required here: BrowserWindow.hide() does not always
 * make document.hidden true.
 */
export function shouldShowDesktopMessageNotification({
  isDndQuiet,
  isMine,
  isMuted,
  messageType,
  isActiveConversation,
  isWindowVisible,
}: DesktopMessageNotificationInput): boolean {
  return !isDndQuiet
    && !isMine
    && !isMuted
    && messageType !== 'system'
    && messageType !== 'call_event'
    && (!isActiveConversation || !isWindowVisible);
}
